import { render, staticRenderFns } from "./ProfileListItem.vue?vue&type=template&id=487942a8&scoped=true"
import script from "./ProfileListItem.vue?vue&type=script&lang=js"
export * from "./ProfileListItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileListItem.vue?vue&type=style&index=0&id=487942a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487942a8",
  null
  
)

export default component.exports